import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectModelId } from "features/Model/_ducks/selectors";
import { selectAllImages, selectLoading } from "store/imageGallery/selectors";
import { saveImageGallery } from "store/imageGallery/thunk";
import { toggleImageGallery, resetImageGallery } from "store/imageGallery/actions";

import { useStateSelector } from "utils/field";

import Input from "components/Input";
import Button from "components/Button";
import ExportNZCaseStudyPDFDrawer from "../ExportNZCaseStudyPDFDrawer";

import styles from "./styles.module.scss";

import SearchIcon from "assets/images/icons/SearchIcon.svg";
import CloseIcon from "assets/images/icons/Close.svg";
import Export from "assets/images/icons/JSX/Export";

const Header = ({
    searchFieldValue,
    setSearchFieldValue,
    toggleImageGallery,
    saveImageGallery,
    allImages,
    isLoading,
    modelId,
    handleSave,
    setIsClosing,
    resetImageGallery,
    isSavingModel = false,
}) => {
    const {
        userPermissions: { CHBA_NZ_ADMIN = false, CHBA_NZEA = false, VOLTA_DEV = false, CHBA_NZ_ASSIST = false } = {},
    } = useStateSelector("user") || {};

    const [isExportCaseStudyOpen, toggleExportCaseStudy] = useState(false);

    return (
        <div className={styles.imageGalleryHeaderContainer}>
            <div>
                <h3 className={styles.headerTitle}>Photo Gallery</h3>
            </div>

            {(CHBA_NZ_ADMIN || CHBA_NZEA || VOLTA_DEV || CHBA_NZ_ASSIST) && (
                <React.Fragment>
                    <div className={styles.exportDcf} style={{ marginTop: "4px" }}>
                        <Button
                            smallPadding
                            onClick={async () => {
                                await saveImageGallery(modelId, allImages);
                                toggleExportCaseStudy(true);
                            }}
                            icon={() => <Export fill={"#fff"} />}
                            className={styles.exportButton}
                            disabled={isSavingModel || isLoading}
                        >
                            Export CHBA NZ Case Study
                        </Button>
                    </div>
                    <ExportNZCaseStudyPDFDrawer
                        isOpen={isExportCaseStudyOpen}
                        onClose={() => toggleExportCaseStudy(false)}
                        handleSave={handleSave}
                    />
                </React.Fragment>
            )}

            <div className={styles.searchCloseWrapper}>
                <Input
                    placeholder="Search (Name, tag, status)"
                    leftIcon={SearchIcon}
                    className={styles.searchInput}
                    style={{ minWidth: "388px" }}
                    input={{ value: searchFieldValue, onChange: (value) => setSearchFieldValue(value) }}
                />
                <div
                    className={styles.closeIcon}
                    onClick={async () => {
                        document.body.style.cursor = "progress";

                        setIsClosing(true);

                        await saveImageGallery(modelId, allImages);
                        await handleSave();

                        toggleImageGallery();
                        setSearchFieldValue("");
                        resetImageGallery();
                        setIsClosing(false);

                        document.body.style.cursor = "default";
                    }}
                >
                    <img src={CloseIcon} alt="close icon" />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    modelId: selectModelId,
    allImages: selectAllImages,
    isLoading: selectLoading,
});

const mapDispatchToProps = (dispatch) => ({
    toggleImageGallery: () => dispatch(toggleImageGallery()),
    saveImageGallery: (modelId, images) => dispatch(saveImageGallery(modelId, images)),
    resetImageGallery: () => dispatch(resetImageGallery()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
